export const COLORS = {
    main: 'rgb(2, 83, 255)',
    red: '#ff4d4f',
    green: '#52c41a',
    orange: '#FFA500',
    gray: '#bdb4b4',
    focusedValue: 'rgba(2, 83, 155, 0.7)',
}
